<template>
  <div class="base-wrapper">
    <!-- 音乐 -->
    <div class="music-wrap" @click="musicToggle" v-if="activityData && activityData.music && activityData.music.isShow">
      <audio ref="bgAudio" loop autoplay :src="activityData.music.musicUrl" @play="audioPlay" @pause="audioPause"></audio>
      <img class="music-img" :class="[bgMusicPlay && 'music-on-img']" :src="bgMusicPlay ? 'http://wapcdn.thecover.cn/activity/annual/music_on.png' : 'http://wapcdn.thecover.cn/activity/annual/music_off.png'" alt="">          
    </div>
    <!-- 引流弹窗 -->
    <!-- <div
      class="activity-download-pop"
      v-if="(activityData && activityData.isAppShow) || isApp"
    >
      <div class="activity-download-pop-inner">
        <p>参加该活动需在封面新闻APP中进行</p>
        <span @click="downLoadApp">确认</span>
      </div>
    </div> -->
    <!-- Toast -->
    <div class="toast-wrapper" v-if="toastData && toastData.text">
      <p class="toast-inner">
        {{ toastData.text }}
      </p>
    </div>
    <!-- 活动结束 -->
    <div class="activity-end" v-if="activityData && activityData.status == 2">
      <img
        src="https://wapcdn.thecover.cn/activity/public/activity_end_1.0.0.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import CONFIG from "@/utils/config";
import COVERAPP from "@/utils/COVERAPP";
import COVER from "@/utils/COVER";

import { mapState, mapActions } from "vuex";

let isTouchPlayMusic = false;

export default {
  data() {
    return {
      bgMusicPlay: false,
    };
  },
  computed: {
    ...mapState(["aid", "isApp", "activityData", "userinfo", "toastData"]),
  },
  watch: {
    'activityData.music.isShow'(val) {
      const _this = this;
      this.$nextTick(() => {
        val && _this.audioPlay();

        document.addEventListener("DOMContentLoaded", () => {
          val && _this.audioPlay();
        });
        
        document.addEventListener("WeixinJSBridgeReady", () => {
          val && _this.audioPlay();
        }, false)

        document.body.addEventListener('touchstart', () => {
          if (!isTouchPlayMusic && val) {
            _this.audioPlay();
          }
          isTouchPlayMusic = true;
        });

      });
    }
  },
  mounted() {
    COVER.isWapHidden();
  },
  methods: {
    //下载APP
    downLoadApp() {
      const openApp = this.activityData.openApp || {};
      COVER.downloadApp(this.aid, openApp.flag, openApp.news_id);
    },
    //音乐播放
    audioPlay() {
      this.$refs.bgAudio.play();
      this.bgMusicPlay = true;
    },
    //音乐暂停
    audioPause() {
      this.$refs.bgAudio.pause();
      this.bgMusicPlay = false;
    },
    // 音乐状态切换
    musicToggle() {
      isTouchPlayMusic = true;
      this.bgMusicPlay = !this.bgMusicPlay;
      if(this.bgMusicPlay) {
        this.audioPlay();
      } else {
        this.audioPause();
      }
    },
  },
};
</script>

<style lang="less">
.music-wrap {
  height: 1rem;
  position: fixed;
  right: .3rem;
  top: 1.2rem;
  width: 1rem;
  z-index: 11;
  audio {
    display: none;
  }
  .music-on-img {
    animation: rotating 1.2s linear infinite;
  }
}
.activity-download-pop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9;
  .activity-download-pop-inner {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    width: 6.5rem;
    padding: 0.5rem;
    background-color: #fff;
    border-radius: 0.2rem;
    box-sizing: border-box;
    font-size: 0.45rem;
    text-align: center;
    p {
      color: #474747;
      line-height: 1.3;
    }
    span {
      display: inline-block;
      min-width: 3.3rem;
      text-align: center;
      color: #fff;
      line-height: 1rem;
      padding: 0 0.3rem;
      background-color: #e62f17;
      margin: 0.3rem 0 0.1rem;
      border-radius: 0.2rem;
      letter-spacing: 0.1rem;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}

.activity-end {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
  img {
    position: absolute;
    bottom: 0;
  }
}
.toast-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.toast-inner {
  font-size: 3.6vw;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 4px;
  padding: 1vw 2vw;
  animation: fadeScale 0.3s 0s ease;
  max-width: 50vw;
  line-height: 1.5em;
}

@keyframes fadeScale {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes rotating {
  from{
    transform: rotate(0deg);
  }
  to{
    transform: rotate(360deg);
  }
}
</style>